import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderEn from '@/components/en/HeaderEn';
import FooterEn from '@/components/en/FooterEn';
import HeroSectionEn from '@/components/en/startpage/HeroSectionEn';
import StatisticsSectionEn from '@/components/en/startpage/StatisticsSectionEn';
import CategoriesSectionEn from '@/components/en/startpage/CategoriesSectionEn';
import KeyInsightsSectionEn from '@/components/en/startpage/KeyInsightsSectionEn';
import NewsReportsSectionEn from '@/components/en/startpage/NewsReportsSectionEn';
import WhistleblowerSectionEn from '@/components/en/startpage/WhistleblowerSectionEn';
import TestimonialsSectionEn from '@/components/en/startpage/TestimonialsSectionEn';
import FocusSectorsSectionEn from '@/components/en/startpage/FocusSectorsSectionEn';
import StartupJourneySectionEn from '@/components/en/startpage/StartupJourneySectionEn';

const IndexEn = () => {
  const navigate = useNavigate();
  const observerRef = useRef<IntersectionObserver>();

  useEffect(() => {
    observerRef.current = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, {
      threshold: 0.1
    });

    const timer = setTimeout(() => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(el => observerRef.current?.observe(el));
    }, 100);

    return () => {
      clearTimeout(timer);
      observerRef.current?.disconnect();
    };
  }, []);

  const handleViewReports = () => {
    navigate('/en/reports');
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'hsl(var(--text-black))' }}>
      <HeaderEn />
      <HeroSectionEn />
      <StatisticsSectionEn />
      <CategoriesSectionEn />
      <FocusSectorsSectionEn />
      <KeyInsightsSectionEn />
      <StartupJourneySectionEn />
      <NewsReportsSectionEn handleViewReports={handleViewReports} />
      <WhistleblowerSectionEn />
      <TestimonialsSectionEn />
      <FooterEn />
    </div>
  );
};

export default IndexEn;
